export default function attchmentPluginTrigger(evt, editor) {
    return (evt.eventType === 6 /* ContentChanged */ ||
        evt.eventType === 7 /* ExtractContent */ ||
        evt.eventType === 0 /* KeyDown */ ||
        evt.eventType === 1 /* KeyPress */);
}
//# sourceMappingURL=attachmentPluginTrigger.js.map